<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/logo.png" alt="logo图" style="height: 50px; width: 50px">
    </div>
    <p class="title">深圳位云科技有限公司</p>
    <p class="address_tel_fax">
      <span>地址：深圳市前海深港合作区前湾一路1号A栋201室</span>
      <span>Tel：18927498115</span>
    </p>
    <p class="email_wx">
      <span>邮箱：184007763@qq.com</span>
      <span>微信号：手机同号</span>
    </p>
    <p class="copy">Copyright &copy; 深圳位云科技有限公司版权所有 2017 - {{ new Date().getFullYear() }}  <a href="http://beian.miit.gov.cn/">粤ICP备2022123369号</a></p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 54px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue